module.exports = __webpack_public_path__ + "img/bootstrap.584d9f32.png";